import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { WaiterAssignment } from '../models/AssignmentModel';

@Injectable({
  providedIn: 'root'
})
export class ServersAssignmentService {

  constructor(private http: HttpClient) { }

  ResGetWaiterAssignConfig(RestaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResGetWaiterAssignConfig?RestaurantId=${RestaurantId}`);
  }
  ResWaitersList(RestaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResWaitersList?RestaurantId=${RestaurantId}`);
  }
  ResSaveWaiterAssignConfig(data: WaiterAssignment) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/ResSaveWaiterAssignConfig`, data);
  }
  ResEditReservationWaiter(data: any) {
    return this.http.post(`${environment.apiUrl}/ResReservation/ResEditReservationWaiter`, data);
  }
  ResTableAssignWaiters(RestaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResTableAssignWaiters?RestaurantId=${RestaurantId}`);
  }
}
